import type { LocaleParams } from '@lotta/self-service/lottery-fe/types-router';
import { getPathWithLocale } from '@lotta/self-service/lottery-fe/util-utilities';
import { Link, useLocation, useParams } from 'react-router-dom';

export type LinkWithLanguageProps = React.ComponentProps<typeof Link>;

/**
 * Components which prefixes path with locale.
 * @param props Props for Link
 * @returns Retuns a link component with path prefixed with locale
 */
export const LinkWithLocale: React.FC<LinkWithLanguageProps> = (props) => {
  const { countryCode, language } = useParams<LocaleParams>() as LocaleParams;
  const { pathname } = useLocation();
  const { to } = props;

  const path = getPathWithLocale(to, pathname, countryCode, language);

  return <Link {...props} to={path} />;
};
